import { isEmpty } from '@ember/utils';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isComparingRates(compareType: unknown, compareValue: unknown) {
  return !isEmpty(compareType) && !isEmpty(compareValue);
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isDateCompare(compareType: string) {
  return compareType === 'extract_date' || compareType === 'swly';
}
